import GroupArrow from './GroupArrow'

const motionButton = {
  GroupArrow,
}

export default motionButton
